import request from "../utils/request";

export const GOOGLE_PLAY_API = {
    listApps: (channelId) => {
        return request.get(`/google-play/channels/${channelId}/apps`);
    },

    addApp: (channelId, data) => {
        return request.post(`/google-play/channels/${channelId}/apps`, data);
    },

    removeApp: (appId) => {
        return request.delete(`/google-play/apps/${appId}`);
    },

    listReviews: (data) => {
        return request.post(`/google-play/reviews`, data);
    },

    fetchReviews: (channelId, packageName, pageToken) => {
        const params = pageToken ? { pageToken } : {};
        return request.get(`/google-play/channels/${channelId}/apps/${packageName}/fetch-reviews`, { params });
    },

    replyReview: (reviewId, data) => {
        return request.post(`/google-play/reviews/${reviewId}/reply`, data);
    },

    updateStatus: (reviewId, status, assigneeId) => {
        return request.put(`/google-play/reviews/${reviewId}/status`, { status, assigneeId });
    },
};
